import http from "./httpService";
import { getConfig } from "../config/config.js";

const config = getConfig();
const serviceEndpoint = config.apiEndpoint + "/noticias";

export async function getNoticia(recordId) {
  try {
    const response = await http.get(serviceEndpoint + "/" + recordId);
    return response.data.record;
  } catch (error) {
    if (error.message.toUpperCase().includes("NETWORK ERROR")) return error.message.toUpperCase();
    else return [];
  }
}

export async function getNoticias() {
  try {
    const response = await http.get(serviceEndpoint);
    return response.data.records;
  } catch (error) {
    if (error.message.toUpperCase().includes("NETWORK ERROR")) return error.message.toUpperCase();
    else return [];
  }
}

export async function saveNoticia(data, parentId) {
  if (data._id) return await http.put(serviceEndpoint + "/" + data._id, data);
  else {
    if (parentId) data.parentId = parentId;
    const response = await http.post(serviceEndpoint, data);
    return response;
  }
}

export async function deleteNoticia(recordId) {
  return await http.delete(serviceEndpoint + "/" + recordId);
}

// Sube la imagen de una noticia ya existente (necesita el _id). Manda el
// nombre del archivo anterior en "oldfile" para que el backend lo borre.
// Devuelve el nombre de archivo generado o false si falla.
export async function uploadImagenNoticia(id, file, oldfile) {
  const formData = new FormData();
  formData.append("file", file);
  if (oldfile) formData.append("oldfile", oldfile);
  try {
    const response = await http.post(serviceEndpoint + "/uploadImagen/" + id, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data.filename;
  } catch (error) {
    return false;
  }
}
